import type { CountryIntelligenceOysterScore } from "@oysterhr/schema"
import { useTranslation } from "react-i18next"
import { countryCodeToName, CountryCode } from "@oysterhr/common"

type OysterTemplateDescriptionAttributes = {
  oysterScore: CountryIntelligenceOysterScore
  countryCode: CountryCode
}

export const OysterTemplateDescription = ({
  countryCode,
  oysterScore,
}: OysterTemplateDescriptionAttributes) => {
  const { t } = useTranslation("hiring_templates/HiringTemplateCard")
  const countryName = countryCodeToName(countryCode)

  return (
    <>
      <div className="mb-4 break-words font-body font-semibold text-black">
        {t(`oysterTemplate.${oysterScore}.mainDescription`, { countryName })}
      </div>
      <div className="mb-8 break-words text-sm text-gray-400 lg:mb-12">
        {t(`oysterTemplate.${oysterScore}.extendedDescription`, { countryName })}
      </div>
    </>
  )
}
